export default __webpack_public_path__ + "static/homeadvisor-b51f1f8833663d84be7a33a20653b5ff.svg";